
@if (isLoading | async) {
  <div class="overlay">
    <mat-progress-spinner class="spinner"
      mode="indeterminate"
      diameter="50"
      >
    </mat-progress-spinner>
  </div>
}